import Vue from 'vue'
import Vuex from 'vuex'
import { router } from './router'

Vue.use(Vuex);

function initialState() {
  return {
    socket: {
      isConnected: false
    },
    username: '',
    authenticated: false,
    programme: [],
    anreden: [],
    praxisarten: [],
    activeProcesses: [],
    current: {
      bestellung: {
        lizenz: {
          aerzte: [],
          behandlungsorte: [],
          asvTeams: [],
          kvAbrechnungsgruppen: [],
          lizenzaenderung: false
        },
        praxisstrukturUploaded: false,
        praxisart: null,
      },
      prices: {},
      process: undefined,
      possiblePraxispartner: [],
    },
    uploadedDocumentResult: {
      message: undefined
    },
    errors: [],
    passwortSaved: false,
    loading: false,
    lizenzaenderung: false,
  }
}

export default new Vuex.Store({
  state: initialState(),
  mutations: {
    SOCKET_ONOPEN(state) {
      state.socket.isConnected = true;
    },
    loginSuccessful(state, data) {
      state.authenticated = data.authenticated;
      state.username = data.username;
      state.programme = data.programme;
      state.anreden = data.anreden;
      state.praxisarten = data.praxisarten;
      state.errors = [];
      state.current.possiblePraxispartner = data.praxisPartner;
      state.lizenzaenderung = data.grantedAuthority.includes('lizenzaenderung')
    },
    setInitialActiveProcesses(state, data) {
      state.activeProcesses = data
    },
    updateActiveProcesses(state, data) {
      let index = state.activeProcesses.findIndex(process => {
        const bestellungIdNotEqual = (process.bestellungId !== data.bestellungId && process.t2medId === data.t2medId);
        const bestellungIdEqualAndProcessIdEqual = (process.bestellungId === data.bestellungId && process.processInstanceID === data.processInstanceID);
        return bestellungIdEqualAndProcessIdEqual || bestellungIdNotEqual
      })
      if (index > -1) {
        state.activeProcesses.splice(index, 1, data)
      } else {
        state.activeProcesses.push(data)
      }
    },
    removeProcess(state, data) {
      const index = state.activeProcesses.findIndex((process => process.bestellungId === data))
      if (index > -1) {
        state.activeProcesses.splice(index, 1)
      }
    },
    startProcess(state, data) {
      state.current.bestellung = data.bestellung;
      state.current.process = data.processID
    },
    updateCurrentLicense(state, data) {
      state.current.bestellung = data
    },
    clearCurrent(state) {
      state.current = initialState().current
    },
    resetState(state) {
      Object.assign(state, initialState());
      router.go('/login')
    },
    updateCurrent(state, data) {
      state.current.bestellung = data.bestellung;
      state.current.process = data.processId;
      state.current.possiblePraxispartner = data.praxisPartner
    },
    updateBehandlungsort(state, data) {
      const index = state.current.bestellung.lizenz.behandlungsorte.findIndex(behandlungsort => behandlungsort.id === data.behandlungsort.id || (behandlungsort.crmId === data.behandlungsort.crmId && behandlungsort.crmId !== null))
      if (index > -1) {
        state.current.bestellung.lizenz.behandlungsorte.splice(index, 1, data.behandlungsort)
      } else {
        state.current.bestellung.lizenz.behandlungsorte.push(data.behandlungsort)
      }
      state.current.bestellung.lizenz.kvAbrechnungsgruppen.forEach(gruppe => {
        const index = gruppe.behandlungsorte.findIndex(behandlungsort => behandlungsort.id === data.behandlungsort.id || (behandlungsort.crmId === data.behandlungsort.crmId && behandlungsort.crmId !== null))
        if (index > -1) {
          gruppe.behandlungsorte.splice(index, 1, data.behandlungsort)
        }
      })
      state.current.bestellung.lizenz.aerzte.forEach(arzt => {
        arzt.arztrollen.forEach(rolle => {
          const index = rolle.behandlungsorte.findIndex(behandlungsort => behandlungsort.id === data.behandlungsort.id || (behandlungsort.crmId === data.behandlungsort.crmId && behandlungsort.crmId !== null))
          if (index > -1) {
            rolle.behandlungsorte.splice(index, 1, data.behandlungsort)
          }
        })
      })
    },
    deleteBehandlungsort(state, data) {
      const index = state.current.bestellung.lizenz.behandlungsorte.findIndex(behandlungsort => behandlungsort.id === data)
      if (index > -1) {
        state.current.bestellung.lizenz.behandlungsorte.splice(index, 1)
      }
    },
    updateArzt(state, data) {
      const index = state.current.bestellung.lizenz.aerzte.findIndex(arzt => arzt.id === data.arzt.id)
      if (index > -1) {
        state.current.bestellung.lizenz.aerzte.splice(index, 1, data.arzt)
      } else {
        state.current.bestellung.lizenz.aerzte.push(data.arzt)
      }
    },
    deleteArzt(state, data) {
      const index = state.current.bestellung.lizenz.aerzte.findIndex(arzt => arzt.id === data)
      if (index > -1) {
        state.current.bestellung.lizenz.aerzte.splice(index, 1)
      }
    },
    updateAbrechnungsgruppe(state, data) {
      const index = state.current.bestellung.lizenz.kvAbrechnungsgruppen.findIndex(gruppe => gruppe.id === data.kvAbrechnungsgruppe.id)
      if (index > -1) {
        state.current.bestellung.lizenz.kvAbrechnungsgruppen.splice(index, 1, data.kvAbrechnungsgruppe)
      } else {
        state.current.bestellung.lizenz.kvAbrechnungsgruppen.push(data.kvAbrechnungsgruppe)
      }
    },
    deleteAbrechnungsgruppe(state, data) {
      const index = state.current.bestellung.lizenz.kvAbrechnungsgruppen.findIndex(gruppe => gruppe.id === data)
      if (index > -1) {
        state.current.bestellung.lizenz.kvAbrechnungsgruppen.splice(index, 1)
      }
    },
    updateASVTeam(state, data) {
      const index = state.current.bestellung.lizenz.asvTeams.findIndex(team => team.id === data.asvteam.id)
      if (index > -1) {
        state.current.bestellung.lizenz.asvTeams.splice(index, 1, data.asvteam)
      } else {
        state.current.bestellung.lizenz.asvTeams.push(data.asvteam)
      }
    },
    deleteASVTeam(state, data) {
      const index = state.current.bestellung.lizenz.asvTeams.findIndex(team => team.id === data)
      if (index > -1) {
        state.current.bestellung.lizenz.asvTeams.splice(index, 1)
      }
    },
    updateDocumentUpload(state, data) {
      state.uploadedDocumentResult.message = data.beanstandung;
      state.current.bestellung = data.bestellung
    },
    startPasswortChange(state) {
      state.passwortSaved = false
    },
    passwordChangedSuccessful(state) {
      state.passwortSaved = true
    },
    setPrices(state, data) {
      state.current.prices = data
    },
    updateAllInfos(state, data) {
      state.current.bestellung.praxisart = data.praxisart
      state.current.bestellung.asvTeamsAktiv = data.asvTeamsAktiv
      state.current.bestellung.bemerkung = data.bemerkung
      state.current.bestellung.manuelleDokumenteLiegenVor = data.manuelleDokumenteLiegenVor
      state.current.bestellung.installDate = data.installDate
      state.current.bestellung.praxisName = data.praxisname
    },
    addError(state, data) {
      if (data.length > 0) {
        const first = data[0];
        state.errors.push({
          id: first.id,
          errors: data.map(error => error.message)
        })
      }
      state.loading = false
    },
    startLoading(state) {
      state.loading = true
    },
    removeError(state, data) {
      const index = state.errors.findIndex(error => error.id === data)
      if (index > -1) {
        state.errors.splice(index, 1)
      }
    }
  },
  actions: {
    LoginResultEvent(context, event) {
      context.commit('addError', event.errorMessages);
      if (event.errorMessages.length === 0) {
        context.commit('loginSuccessful', event);
        router.push(router.currentRoute.query.redirect || '/')
      }
    },
    ActiveProcessesResultEvent(context, event) {
      context.commit('addError', event.errorMessages);
      context.commit('setInitialActiveProcesses', event.activeProcesses)
    },
    UpdateOverviewResultEvent(context, event) {
      context.commit('addError', event.errorMessages);
      if (event.update != null) {
        context.commit('updateActiveProcesses', event.update)
      }
      if (event.removed != null) {
        context.commit('removeProcess', event.removed)
      }
    },
    NextTaskResultEvent(context, event) {
      context.commit('addError', event.errorMessages);
      if (event.errorMessages.length === 0) {
        router.push(`/${event.taskDefinitionKey}/${event.processId}/${event.taskId}`)
      }
    },
    StarteNeubestellungResultEvent(context, event) {
      context.commit('addError', event.errorMessages);
      if (event.errorMessages.length === 0) {
        context.commit('startProcess', event);
        context.commit('setPrices', event.prices);
        router.push(`/${event.firstUIComponentTO.definitionKey}/${event.processID}/${event.firstUIComponentTO.instanceId}`)
      }
    },
    StartModificationResultEvent(context, event) {
      context.commit('addError', event.errorMessages);
      if (event.errorMessages.length === 0) {
        router.push(`/${event.firstUIComponentTO.definitionKey}/${event.processID}/${event.firstUIComponentTO.instanceId}`)
      }
    },
    PraxisstrukturSaveResultEvent(context, event) {
      context.commit('addError', event.errorMessages);
      if (event.errorMessages.length === 0) {
        context.commit('updateCurrentLicense', event.bestellung)
      }
    },
    BestellungResultEvent(context, event) {
      context.commit('addError', event.errorMessages);
      if (event.authorized) {
        context.commit('updateCurrent', event);
        context.commit('setPrices', event.prices);
        router.push(`/${event.taskDefinitionKey}/${event.processId}/${event.taskId}`)
      } else {
        context.commit('clearCurrent');
        router.push('/')
      }
    },
    BehandlungsorteSaveResultEvent(context, event) {
      context.commit('addError', event.errorMessages);
      if (event.errorMessages.length === 0) {
        context.commit('updateBehandlungsort', event)
      }
    },
    BehandlungsortDeleteResultEvent(context, event) {
      context.commit('addError', event.errorMessages);
      if (event.errorMessages.length === 0) {
        context.commit('deleteBehandlungsort', event.behandlungsortId)
      }
    },
    ArztSaveResultEvent(context, event) {
      context.commit('addError', event.errorMessages);
      if (event.errorMessages.length === 0) {
        context.commit('updateArzt', event)
      }
    },
    ArztDeleteResultEvent(context, event) {
      context.commit('addError', event.errorMessages);
      if (event.errorMessages.length === 0) {
        context.commit('deleteArzt', event.arztID)
      }
    },
    KVAbrechnungsgruppeSaveResultEvent(context, event) {
      context.commit('addError', event.errorMessages);
      if (event.errorMessages.length === 0) {
        context.commit('updateAbrechnungsgruppe', event)
      }
    },
    KVAbrechnungsgruppeDeleteResultEvent(context, event) {
      context.commit('addError', event.errorMessages);
      if (event.errorMessages.length === 0) {
        context.commit('deleteAbrechnungsgruppe', event.kvAbrechnungsgruppeId)
      }
    },
    ASVTeamSaveResultEvent(context, event) {
      context.commit('addError', event.errorMessages);
      if (event.errorMessages.length === 0) {
        context.commit('updateASVTeam', event)
      }
    },
    ASVTeamDeleteResultEvent(context, event) {
      context.commit('addError', event.errorMessages);
      if (event.errorMessages.length === 0) {
        context.commit('deleteASVTeam', event.asvTeamId)
      }
    },
    StopProcessResultEvent(context, event) {
      context.commit('addError', event.errorMessages)
    },
    BestelldokumenteUploadResultEvent(context, event) {
      context.commit('addError', event.errorMessages);
      if (event.errorMessages.length === 0) {
        router.push('/')
      }
    },
    BestelldokumenteUploadOverviewResultEvent(context, event) {
      context.commit('addError', event.errorMessages);
      if (event.errorMessages.length === 0) {
        context.commit('updateDocumentUpload', event)
      }
    },
    BestellungStornierenResultEvent(context, event) {
      context.commit('addError', event.errorMessages);
      if (event.errorMessages.length === 0) {
        router.push("/")
      }
    },
    UebersichtDocumentResultEvent(context, event) {
      context.commit('addError', event.errorMessages);
      if (event.errorMessages.length === 0 && event.overview !== undefined && event.overview !== null && event.overview !== "") {
        const linkSource = `data:application/pdf;base64,${event.overview}`;
        const downloadLink = document.createElement("a");
        const fileName = "Übersicht.pdf";
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink)
      }
    },
    CreateDocumentResultEvent(context, event) {
      context.commit('addError', event.errorMessages);
      if (event.errorMessages.length === 0 && event.document !== undefined && event.document !== null && event.document !== "") {
        const linkSource = `data:application/pdf;base64,${event.document}`;
        const downloadLink = document.createElement("a");
        const fileName = "Bestelldokument.pdf";
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink)
      }
    },
    BankdatenSaveResultEvent(context, event) {
      context.commit('addError', event.errorMessages);
      if (event.errorMessages.length === 0) {
        context.commit('updateBehandlungsort', event)
      }
    },
    ChangePasswordResultEvent(context, event) {
      context.commit('addError', event.errorMessages);
      if (event.errorMessages.length === 0) {
        context.commit('passwordChangedSuccessful')
      }
    },
    UebersichtCompleteResultEvent(context, event) {
      context.commit('addError', event.errorMessages);
    },
    LogoutEvent(context) {
      context.commit('resetState')
    },
    PraxisartSaveResultEvent(context, event) {
      context.commit('addError', event.errorMessages);
      if (event.errorMessages.length === 0) {
        context.commit('updateAllInfos', event)
        router.push(`/${event.taskDefinitionKey}/${event.processId}/${event.taskId}`)
      }
    },
  },
  getters: {
    authenticated: state => {
      return state.authenticated
    }
  }
})
